<template>
  <div
    class="d-flex flex-column gap-2 editable-key-value"
    :class="{ 'always-show-edit-button': alwaysShowEditButton }">
    <div class="d-flex flex-row justify-space-between align-start flex-1">
      <key-value
        :label="label"
        :labelIcon="labelIcon"
        :value="isEditing ? null : value"
        :valueIcon="isEditing ? null : valueIcon"
        style="flex: 1"
        :labelProps="labelProps"
        :valueProps="valueProps">
        <template #label>
          <slot name="label"></slot>
        </template>
        <template #value>
          <slot name="editing-value" v-if="isEditing"></slot>
          <slot name="value" v-else></slot>
        </template>
      </key-value>

      <div v-if="canEdit && !isEditing">
        <v-btn
          icon
          variant="plain"
          size="small"
          class="edit-button"
          :title="t('yard.tooltips.editData')"
          @click="emit('edit')"
          v-bind="editButtonProps">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
    </div>

    <div v-if="canEdit && isEditing" class="d-flex flex-column gap-2 flex-1">
      <div class="justify-end d-flex flex-row gap-2">
        <v-btn size="small" @click="emit('cancel')" variant="outlined" v-bind="cancelButtonProps">
          {{ t('global.buttons.nevermind') }}
        </v-btn>
        <v-btn
          size="small"
          color="primary"
          variant="flat"
          @click="emit('save')"
          v-bind="saveButtonProps">
          {{ t('global.buttons.save') }}
        </v-btn>
      </div>
    </div>

    <slot></slot>
  </div>
</template>
<script>
import { useI18n } from 'vue-i18n';
import KeyValue from './KeyValue.vue';

export default {
  components: {
    KeyValue
  },
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    labelIcon: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    valueIcon: {
      type: String,
      required: false,
      default: null
    },
    labelProps: {
      type: Object,
      required: false,
      default: () => ({})
    },
    valueProps: {
      type: Object,
      required: false,
      default: () => ({})
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    alwaysShowEditButton: {
      type: Boolean,
      required: false,
      default: false
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: false
    },
    editButtonProps: {
      type: Object,
      default: () => ({})
    },
    cancelButtonProps: {
      type: Object,
      default: () => ({})
    },
    saveButtonProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['edit', 'cancel', 'save'],
  setup(_, context) {
    const emit = context.emit;
    const { t } = useI18n();

    return {
      emit,
      t
    };
  }
};
</script>
<style lang="scss">
/* Always visible by default to cover for touch devices */
.editable-key-value .edit-button {
  opacity: 1;
  padding: 0;
  background-color: $white;
  transition: opacity 0.3s ease-in-out;
}

/* On hover-capable devices, fade in on hover */
@media (hover: hover) and (pointer: fine) {
  .editable-key-value:not(.always-show-edit-button) .edit-button {
    opacity: 0;
  }
  .editable-key-value:hover .edit-button {
    opacity: 1;
  }
}

.editable-key-value form {
  // overrides a global padding-top set in the satellite library
  padding-top: 0 !important;
}
</style>
